// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  :root {
    --v-focus-color: var(--gc-color-primary-rgb);
    --v-focus-box-shadow: 0 0 0 0.2rem rgba(var(--v-focus-color), 0.5);
    --v-border-radius: 4px;
  }
  :root .v-component-container .p-button:not(.p-inputnumber-button), :root .v-component-container .p-multiselect {
    min-height: 48px;
  }
  :root .v-component-container .p-inputtext, :root .v-component-container .p-dropdown {
    background: var(--v-input-background-color);
  }
  :root .v-component[hidden] {
    display: none;
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}
@layer vierkant {
  .v-validate-pristine--style, .v-formControl.v-validate-pristine .ng-invalid.v-component-container, .v-formControl.v-validate-pristine .ng-invalid.p-component,
  .v-formControl .ng-invalid.ng-dirty.v-component-container,
  .v-formControl .ng-invalid.ng-dirty.p-component {
    --dropdown-border: 1px solid var(--gc-color-danger);
    border-color: var(--gc-color-danger) !important;
    outline: solid 1px var(--gc-color-danger);
    outline-offset: -4px;
  }
  .v-required .v-component-label:after,
  .v-formControl.v-required .v-component-label:after {
    content: "*";
    margin-left: 0.25rem;
    color: var(--gc-color-danger);
  }
  .v-readonly, .v-readonly input {
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}
@layer vierkant {
  :host, .v-component {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  .v-component-container {
    position: relative;
    display: grid;
  }
  .v-component-container:focus, .v-component-container input:focus {
    box-shadow: var(--v-focus-box-shadow);
  }
  .v-component-container input:hover {
    border-color: var(--gc-color-primary);
  }
  .v-component-container .affix {
    text-align: center;
  }
  .v-component-container .p-inputtext {
    min-height: 48px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/style.sass","webpack://./src/app/modules/wrappers/lib/input.style.sass","webpack://./src/app/modules/wrappers/lib/validation.sass"],"names":[],"mappings":"AAAA;EACI;IACI,4CAAA;IACA,kEAAA;IACA,sBAAA;ECCN;EDMU;IACI,gBAAA;ECJd;EDKU;IACI,2CAAA;ECHd;EDMU;IACI,aAAA;IACA,yBAAA;YAAA,iBAAA;IACA,oBAAA;ECJd;AACF;ACjBA;EACI;;;IACI,mDAAA;IACA,+CAAA;IACA,yCAAA;IACA,oBAAA;EDqBN;ECnBE;;IAEI,YAAA;IACA,oBAAA;IACA,6BAAA;EDqBN;ECfE;IACI,yBAAA;YAAA,iBAAA;IACA,oBAAA;EDiBN;AACF;AAnCA;EACI;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,YAAA;EAqCN;EApCE;IACI,kBAAA;IACA,aAAA;EAsCN;EArCM;IACI,qCAAA;EAuCV;EAtCM;IACI,qCAAA;EAwCV;EAtCM;IACI,kBAAA;EAwCV;EAtCM;IACI,gBAAA;EAwCV;AACF","sourcesContent":["@layer vierkant\n    :root\n        --v-focus-color: var(--gc-color-primary-rgb)\n        --v-focus-box-shadow: 0 0 0 0.2rem rgba(var(--v-focus-color), 0.5)\n        --v-border-radius: 4px\n\n        .v-component-container\n            // .p-element\n                // transition-property: background-color, color, border-radius, outline, border\n                // transition-duration: 0.25s\n                // transition-timing-function: ease-out\n            .p-button:not(.p-inputnumber-button), .p-multiselect\n                min-height: 48px\n            .p-inputtext, .p-dropdown\n                background: var(--v-input-background-color)\n\n        .v-component\n            &[hidden]\n                display: none\n                user-select: none\n                pointer-events: none","@use './style.sass'\n@use './validation.sass'\n@layer vierkant\n    :host, .v-component\n        display: flex\n        flex-direction: column\n        align-items: flex-start\n        gap: 0.25rem\n    .v-component-container\n        position: relative\n        display: grid\n        &:focus, input:focus\n            box-shadow: var(--v-focus-box-shadow)\n        input:hover\n            border-color: var(--gc-color-primary)\n\n        .affix\n            text-align: center\n    \n        .p-inputtext\n            min-height: 48px","@layer vierkant\n    .v-validate-pristine--style\n        --dropdown-border: 1px solid var(--gc-color-danger)\n        border-color: var(--gc-color-danger) !important\n        outline: solid 1px var(--gc-color-danger)\n        outline-offset: -4px\n\n    .v-required .v-component-label:after,\n    .v-formControl.v-required .v-component-label:after\n        content: '*'\n        margin-left: 0.25rem\n        color: var(--gc-color-danger)\n    .v-formControl.v-validate-pristine .ng-invalid, \n    .v-formControl .ng-invalid.ng-dirty\n        &.v-component-container, &.p-component\n            @extend .v-validate-pristine--style    \n\n    .v-readonly, .v-readonly input\n        user-select: none\n        pointer-events: none"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
